export enum PermissionsAdminPagesEnum {
  Admin = 1,
  Clients = 2,
  Users = 3,
  LoginHistory = 4,
  UserPermissions = 5,
  UserRoles = 6
}
